import type { SvgIconComponent } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

type BookingDetailSectionTitleProps = {
  icon: SvgIconComponent;
  children: ReactNode;
  /** Renders on the right (e.g. edit control). */
  action?: ReactNode;
  /** Place the action on the line under the title so wide buttons do not cover the heading. */
  actionBelow?: boolean;
  sx?: SxProps<Theme>;
};

export function BookingDetailSectionTitle({
  icon: Icon,
  children,
  action,
  actionBelow = false,
  sx,
}: BookingDetailSectionTitleProps) {
  const title = (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
      <Icon sx={{ fontSize: 22, color: 'primary.main', flexShrink: 0 }} />
      <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 700, lineHeight: 1.3 }}>
        {children}
      </Typography>
    </Stack>
  );

  if (action && actionBelow) {
    return (
      <Stack spacing={1} sx={{ mb: 1, ...sx }}>
        {title}
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>{action}</Box>
      </Stack>
    );
  }

  if (action) {
    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
        sx={{ mb: 1, flexWrap: 'nowrap', ...sx }}>
        {title}
        <Box sx={{ ml: 'auto', flexShrink: 0, display: 'flex', alignItems: 'center' }}>{action}</Box>
      </Stack>
    );
  }

  return <Stack sx={{ mb: 1, ...sx }}>{title}</Stack>;
}
